import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ConsentIcon from '../icons/consentIcon';
import ControlPanelButton from '../controlPanelButton';

const PatientStatusAndCovidStatus = ({ profile, patientDetailsLoading }) => {
  const {
    adminPanelPatients: { getPatientDetailsWithCcmData },
  } = useDispatch();

  const patient = useSelector((state) => state.adminPanelPatients.patient);
  const consentLabel = patient.profile.ccmConsentFormStatus
    ? 'Consent Confirmed'
    : 'Consent Not Confirmed';

  useEffect(async () => {
    await getPatientDetailsWithCcmData(profile.guid);
  }, []);

  const covidStatusSubmitLoading = useSelector(
    (state) => state.loading.effects.covid.submit,
  );

  const click = () => {
    window.open(
      `/ccm/consent/${profile.guid}`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <>
      <div className="admin-patient-header-actions-call">
        <ControlPanelButton
          label={consentLabel}
          icon={ConsentIcon}
          handleClick={click}
          disabled={patientDetailsLoading || covidStatusSubmitLoading}
        />
      </div>
    </>
  );
};

PatientStatusAndCovidStatus.defaultProps = {
  patientDetailsLoading: false,
};

PatientStatusAndCovidStatus.propTypes = {
  profile: PropTypes.shape().isRequired,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientStatusAndCovidStatus;
